import axios from 'axios';
import * as utils from './Utils';
import thdcustomer from '@thd-olt-global/thd-customer';

export const executeLoggerService = (obj) => {
  const url = 'https://' + window.location.host + '/account/log/servicelog';
  axios.post(url, obj)
    .then(
      () => {
        console.log('save card logging successful');
      },
      () => {
        console.log('failed logging save card info');
      }
    );
};

export const getResponseTime = (startTime) => {
  try {
    return (startTime && startTime !== '1') ? (Math.round((new Date()) - startTime).toString()) : '1';
  } catch (e) {
    return 1;
  }
};

export const getLoggerRequest = (url, dataObj, respCode, startTime) => {
  const resp = (typeof dataObj === 'object') ? Object.assign({}, dataObj) : dataObj;
  return {
    appname: 'account',
    tablename: 'eventlog',
    rows: [
      {
        operation: 'INSERT',
        columns: {
          global_id: thdcustomer.svocID ? thdcustomer.svocID : '',
          user_type: thdcustomer.customerType ? thdcustomer.customerType : 'B2C',
          service_request_ts: '',
          component: thdcustomer.customerType + '_myAccount' + (utils.readCookie('HD_DC') === 'beta' ? '&beta' : ''),
          serviceURL: url,
          request: '',
          response: JSON.stringify(resp),
          responseCode: respCode.toString(),
          responseTime: getResponseTime(startTime, new Date()),
          http_method: 'GET',
          x_device: window.THD_ACCOUNT_GLOBAL.isNativeApp === 'true' ? 'NativeApp' : utils.isMobile() ? 'mobile' : 'desktop',
          user_agent: utils.getUserAgent(),
          miscellaneous: utils.readCookie('QuantumMetricSessionID') ? 'qmSessionId=' + utils.readCookie('QuantumMetricSessionID') + '_qmUserId=' + utils.readCookie('QuantumMetricUserID') : '',
          featureSwitch: 'true'
        }
      }
    ]
  };
};

export const logEvents = (data) => {
  const url = '/customer/account/v1/citi/12345/saveCardToProfile';
  const logObj = getLoggerRequest(url, data, 200);
  executeLoggerService(logObj);
}



// WEBPACK FOOTER //
// ./src/Components/SaveThdCreditCard/Logger.service.js